// Based on https://tympanus.net/codrops/2015/09/15/styling-customizing-file-inputs-smart-way/
function customizeFileInputs(form) {
	const inputs = form.querySelectorAll('[type="file"]');

	inputs.forEach(input => {
		const label = input.nextElementSibling;
		const selection = label.querySelector('[data-form="labelValue"]');
		const initialText = selection.innerHTML;

		input.addEventListener('change', function (event) {
			let fileName = '';
			if (this.files && this.files.length > 1) {
				fileName = (this.getAttribute('data-multiple-caption') || '').replace(
					'{count}',
					this.files.length
				);
			} else {
				fileName = event.target.value.split('\\').pop();
			}

			selection.innerHTML = fileName || initialText;
		});
	});
}

export { customizeFileInputs };
